import {
  PublicClientApplication,
  Configuration,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

export type config = {
  msal: Configuration;
  login: {
    scopes: string[];
  };
};

let instance: PublicClientApplication | null = null;

export const getMsalInstance = async (
  config: Configuration
): Promise<PublicClientApplication> => {
  if (!instance) {
    instance = new PublicClientApplication(config);
    await instance.initialize();
  }

  return instance;
};

export const mslaGetUser = async (config: config) => {
  const app = await getMsalInstance(config.msal);
  const currentAccounts = app.getAllAccounts();
  return currentAccounts[0] || null;
};

export const mslaGetToken = async (
  config: config,
  success: (token: string) => void,
  failed?: () => void
): Promise<void> => {
  try {
    const user = await mslaGetUser(config);
    if (!user) {
      if (typeof failed === "function") failed();
      return;
    }

    const app = await getMsalInstance(config.msal);

    app
      .acquireTokenSilent({
        ...config.login,
        account: user,
      })
      .then((resp) => {
        success(resp.accessToken);
      })
      .catch((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          app
            .acquireTokenPopup({
              ...config.login,
              account: user,
            })
            .then((accessTokenResponse) => {
              success(accessTokenResponse.accessToken);
            })
            .catch(() => {
              if (typeof failed === "function") failed();
            });
        } else {
          if (typeof failed === "function") failed();
        }
      });
  } catch (err) {
    console.error("Erro on mslaGetToken:", err);
    if (typeof failed === "function") failed();
  }
};

export const mslaLoginPopup = async (
  config: config,
  successCallback: (token: string) => void,
  errorCallback: () => void
): Promise<void> => {
  try {
    const app = await getMsalInstance(config.msal);
    await app.loginPopup(config.login);
    mslaGetToken(config, successCallback, errorCallback);
  } catch (error) {
    errorCallback();
  }
};

export const mslaLogout = async (config: config): Promise<void> => {
  const app = await getMsalInstance(config.msal);
  await app.logoutPopup();
};
